export enum EFormItemSize {
  xs32 = 'xs32',
  s36 = 's36',
  m40 = 'm40',
  l48 = 'l48',
  xl56 = 'xl56',
}
